var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-dropdown', {
    staticClass: "filtro-dropdown",
    attrs: {
      "size": "sm",
      "text": _vm.selected.label,
      "variant": "light"
    }
  }, _vm._l(_vm.options, function (option) {
    var _vm$selected;
    return _c('b-dropdown-item', {
      key: option.id,
      attrs: {
        "active": ((_vm$selected = _vm.selected) === null || _vm$selected === void 0 ? void 0 : _vm$selected.id) === option.id
      },
      on: {
        "click": function click($event) {
          return _vm.changed(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.label) + " ")]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };